module.exports = __webpack_public_path__ + "static/media/rocket.c6e77f0d.svg";